export default __webpack_public_path__ + "static/media/thrivecart-dark.5f66b834.svg";